<template>
  <div @click.stop.prevent="IsMobile()?showOrFalse():plays()" class="control" :data-screen="displayStatus" :style="{'width':width,'height':height}">
    <video crossorigin="anonymous" :class="{scaleSet:scaleChoose}" preload="auto" :src="src" ref="videos" width="100%" height="100%" :poster="placeholderImage"></video>

    <div class="control-wrap" @click.stop="" @touchstart.stop="" @mouseenter="prohibit" @mouseleave="Restart">
      <div ref="control" class="control-top" @click.stop="adjustProgress($event)" :style="IsMobile()? 'height:5px;' : ''">
        <!-- 进度条 -->
        <div class="control-top-bar" :style="{ width: progressWidth }" >
          <div :class="['slider_circle',{showOrHide:IsMobile() ? (parseFloat(progressWidth) > 0) : enters}]" @click.stop.prevent="" @mousedown.stop.prevent="handleSliderMouseDown" @touchstart.stop.prevent="handleSliderTouchstart">
            <div class="el-slider__button"></div>
          </div>
        </div>
      </div>
      <div class="control-bottom" ref="controlBottom">
        <!-- 渐变黑色背景 -->
        <div class="control-mask"></div>
        <div class="control-bottom-control">
          <div class="control-bottom-left">
            <div :class="pauses? 'video-play' : 'video-pause'" @click.stop="plays()"></div>
            <div class="timer"><span>{{ currentTime }}</span><span class="videoAdapter" v-show="videoWidth > 450">/{{ totalTime }}</span> </div>
          </div>
          <div class="control-bottom-right">
            <div class="bpx-player-ctrl-btn ctrl-quality" v-show="videoWidth > 450">
              <div class="ctrl-quality-result" @click.stop='' @mouseenter="quality=true" @mouseleave="leave('quality')">{{qualityResult}}</div>
              <ul class="ctrl-quality-menu bpx-player-ctrl-menu" v-show="quality" @mouseenter="quality='1'" @mouseleave="quality=false">
                <li :class="['ctrl-quality-menu-item',{active:qualityChoose==ind}]" @click.stop="qualityChoose=ind,qualityResult=item" v-for="(item,ind) in qualityMenu" :key="ind">
                  <span>{{item}}</span>  
                </li>
              </ul>
            </div>
            <div class="bpx-player-ctrl-btn ctrl-playbackrate" v-show="videoWidth > 315">
              <div class="ctrl-playbackrate-result" @click.stop='' @mouseenter="playbackrate=true" @mouseleave="leave('playbackrate')">倍速</div>
              <ul class="ctrl-playbackrate-menu bpx-player-ctrl-menu" v-show="playbackrate"  @mouseenter="playbackrate='1'" @mouseleave="playbackrate=false">
                <li :class="['ctrl-playbackrate-menu-item',{active:playbackrateChoose==ind}]" v-for="(item,ind) in playbackrateMenu" :key="ind" @click.stop="setPlayRate(item,ind)">
                  <span>{{item}}X</span>  
                </li>
              </ul>
            </div>
            <!-- 音量 -->
            <div class="bpx-player-ctrl-btn player-ctrl-volume">
              <div class="icon icon-size"  @click.stop="toShowVolumeBar" @mouseenter="isShowVolumeBar=true" @mouseleave="leave('isShowVolumeBar')"></div>
              <div class="volumeBar bpx-player-ctrl-menu" @click.stop="" v-show="isShowVolumeBar" @mouseenter="isShowVolumeBar='1'"  @mouseleave="isShowVolumeBar=false">
                  <span>{{volume}}</span>
                  <el-slider
                      v-model="volume"
                      vertical
                      :show-tooltip="false"
                      height="100px"
                      @input="changeVolume">
                  </el-slider>
              </div>
            </div>
            <!-- 设置 -->
            <div class="bpx-player-ctrl-btn player-ctrl-setting" v-show="videoWidth > 270">  
              <div class="icon icon-s-tools" @click.stop='' @mouseenter="ctrlSetting=true" @mouseleave="leave('ctrlSetting')"></div>
              <ul class="ctrl-setting-menu bpx-player-ctrl-menu" v-show="ctrlSetting" @mouseenter="ctrlSetting='1'" @mouseleave="ctrlSetting=false">
                <li @click.stop="downloads">
                  <span>下载</span>
                </li>
                <li @click.stop="">
                  <span>洗脑循环</span>
                  <el-switch
                    v-model="value"
                    active-color="#0d78cf"
                    inactive-color="#999999"
                    @change="settingLoop">
                  </el-switch>
                </li>
                <li>
                  <span>视频比例</span>
                  <div class="ctrl-setting-scale">
                    <span :class="{'active':proportionChoose==index}" v-for="(ite,index) in proportion" :key="index" @click.stop="proportionSet(index)">{{ite}}</span>
                  </div>
                </li>
              </ul>
            </div>
            <div class="bpx-player-ctrl-btn player-ctrl-pip" @click.stop="ctrlPip" v-show="videoWidth > 230&&!IsMobile()">
              <div class="icon icon-news"></div>
              <div class="player-ctrl-pip-menu bpx-player-ctrl-menu">
                  <li>开启画中画</li>
              </div>
            </div>
            <div class="bpx-player-ctrl-btn player-ctrl-web" @click.stop="fullscreen">
              <div class="icon icon-full-screen"></div>
              <div class="player-ctrl-web-menu bpx-player-ctrl-menu">
                  <li>开启全屏</li>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>
    <div class="ImageLayer" v-show="imageShow" @click.stop.prevent="jumpUrl">
      <img src="~@/assets/image/images/videoImage.png" alt="" width="100%" height="100%">
    </div>
  </div>
</template>
<script>
export default {
    name:'videos',
    props:{
        src:String,
        title:String,
        width:String,
        height:String
    },
    data(){
      return{
        imageShow:false,
        displayStatus:'normal',
        pauses:true,
        currentTime:'00:00',
        totalTime:'00:00',
        progressWidth:0,
        qualityMenu:['480P 清晰','360P 流畅'],
        proportion:['自动','4:3','16:9'],
        playbackrateMenu:['2.0','1.5','1.25','1.0','0.75','0.5'],
        volume:60,
        isShowVolumeBar:false,
        qualityResult:'360P 流畅',
        quality:false,
        playbackrate:false,
        ctrlSetting:false,
        qualityChoose:1,
        proportionChoose:0,
        playbackrateChoose:3,
        value:false,
        scaleChoose:false,
        enters:false,
        videoWidth:0,
        placeholderImage:window.$imageL
      }
    },
    created(){
      if(!window.$imageL){
        this.getFirstFrameFromVideoUrl(this.src).then((dataUrl) => { 
          this.placeholderImage = dataUrl;
        }).catch((error) => { console.error('Error getting first frame:', error); });
      }
    },
    mounted(){
      var that = this,myVideo = that.$refs.videos;
      that.videoWidth = myVideo.offsetWidth;
      //监听播放开始
      myVideo.addEventListener('play',function(){
            that.pauses = false;
            that.videoWidth = myVideo.offsetWidth;
            // 定时器实时刷新
            that.clearTimer()
            that.timer = setInterval(that.updateVideoProgress, 1000)
            that.updateVideoProgress()
      });
      myVideo.addEventListener('resize', () => {
        that.videoWidth = myVideo.offsetWidth;
      })
      myVideo.addEventListener('loadedmetadata', () => {
        //获取视频时长
        that.totalTime = this.formatSeconds(myVideo.duration);
      });
      //监听播放暂停
      myVideo.addEventListener('pause',function(){
            that.pauses = true;
            that.clearTimer()
      });
    },
    methods:{
      getFirstFrameFromVideoUrl(videoUrl) {
				return new Promise((resolve, reject) => {
					const video = document.createElement('video');
					video.crossOrigin = 'anonymous';
					video.src = videoUrl;
					video.onloadedmetadata = () => {
						video.currentTime = 1;
					};
					video.onseeked = () => {
						const canvas = document.createElement('canvas');
						canvas.width = video.videoWidth;
						canvas.height = video.videoHeight;
						const ctx = canvas.getContext('2d');
						ctx.drawImage(video, 0, 0);
						const dataUrl = canvas.toDataURL();
						resolve(dataUrl);
					};
					video.onerror = reject;
				});
			},
      downloads(){
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/cmeplaza/i) == "cmeplaza" && !ua.match(/electron/i)){
          var id = this.src.split('/')[this.src.split('/').length - 1];
          var mId = id.indexOf('.') > -1 ? id.split('.')[0] : id;
          var map = {
            "handleName":"fileDownload",
            "params":{
              "originalName": (this.title || '视频') + '.mp4', //文件名称
              "id": mId, //文件id
              "fileType": "mp4", //文件扩展名
              "type": "2", 
            }
          }
          this.postToApp(map);
        }else{
          var anchor = document.createElement("a");
          anchor.download = (this.title || '视频') + '.mp4';
          anchor.href = this.src;
          anchor.target = "_blank";
          anchor.style.display = "none"; // just to be safe! 
          document.body.appendChild(anchor);
          anchor.click();
          document.body.removeChild(anchor);
        }
      },
      jumpUrl(){
        this.open('https://520emv.com/uoqid/download?appId=zjsqe','_blank');
      },
      prohibit(){
        $('.swiper-container').addClass('swiper-no-swiping');
      },
      Restart(){
        $('.swiper-container').removeClass('swiper-no-swiping');
      },
      proportionSet(index){
        this.proportionChoose=index;
        if(index == 1){
          this.scaleChoose=true;
        }else{
          this.scaleChoose=false;
        }

      },
      fullscreen(){
        if(this.IsApp().iOS){
          this.$refs.videos.requestFullscreen();
          this.$refs.videos.play();
          this.imageShow = false;
          return;
        }
        if(this.displayStatus == 'normal'){
          this.toFullScreen(document.querySelector('.control'));
          if(screen.orientation){
            screen.orientation.lock('landscape').catch(e => console.warn('Screen orientation lock failed:', e));;
          }
          this.$refs.videos.play();
          this.imageShow = false;
          this.displayStatus = 'full'
        }else{
          this.exitFullscreen(parent.document);
          if(screen.orientation){
            screen.orientation.unlock();
          }
          this.displayStatus = 'normal'
        }
      },
      toFullScreen(elem){
          elem.webkitRequestFullScreen
          ? elem.webkitRequestFullScreen()
          : elem.mozRequestFullScreen
          ? elem.mozRequestFullScreen()
          : elem.msRequestFullscreen
          ? elem.msRequestFullscreen()
          : elem.requestFullScreen
          ? elem.requestFullScreen()
          : alert("浏览器不支持全屏");
      },
      exitFullscreen(elem){
          elem.webkitCancelFullScreen
          ? elem.webkitCancelFullScreen()
          : elem.mozCancelFullScreen
          ? elem.mozCancelFullScreen()
          : elem.cancelFullScreen
          ? elem.cancelFullScreen()
          : elem.msExitFullscreen
          ? elem.msExitFullscreen()
          : elem.exitFullscreen
          ? elem.exitFullscreen()
          : alert("切换失败,可尝试Esc退出");
      },
      settingLoop(open){
          this.$refs.videos.loop = open;
      },
      ctrlPip(){
        this.$refs.videos.requestPictureInPicture();
        this.$refs.videos.play();
        this.imageShow = false;
      },
      leave(item){
        setTimeout(()=>{
          switch (item){
            case 'quality':
              if(this.quality !== '1'){
                this.quality = false;
              }
            break;
            case 'playbackrate':
              if(this.playbackrate !== '1'){
                this.playbackrate = false;
              }
            break;
            case 'isShowVolumeBar':
              if(this.isShowVolumeBar !== '1'){
                this.isShowVolumeBar = false;
              }
            break;
            case 'ctrlSetting':
              if(this.ctrlSetting !== '1'){
                this.ctrlSetting = false;
              }
            break;
          }
        },200)
        
      },
      //改变速率
      setPlayRate(rate,ind){
        this.playbackrateChoose=ind;
        this.$refs.videos.playbackRate = rate;
      },
      toShowVolumeBar(){

      },
      //改变音量
      changeVolume(val){
          this.volume = val;
          //由于h5规定volum的值在0-1之间，所以这里要对获取到的val做一个处理(滑块的val是从0-100)
          this.$refs.videos.volume = val / 100;
      },
      adjustProgress(e) {
        e.preventDefault()
        // 这里的this.controlRef = this.$refs.control，加载完视频后定义即可
        const { left, width } = this.$refs.control.getBoundingClientRect()
        // left: 进度条容器control到最左侧的距离，width：容器的宽度
          // e.clientX：鼠标点击的位置到最左侧的距离
        const progressWidth = e.clientX - left;
        this.progressWidth = progressWidth + 'px'
        this.$refs.videos.play()
        this.imageShow = false;
        this.pauses = false;
        this.updadteCurrentTime(progressWidth, width)
      },
      handleSliderMouseDown(event) {
        event.preventDefault()
        this.enters = true;
        // 滑块点击坐标
        const offsetX = event.offsetX
        document.onmousemove = this.mouseMove(offsetX);
        //抬起鼠标，结束移动事件
        document.onmouseup = this.mouseUp;
      },
      handleSliderTouchstart(event){
        event.preventDefault()
        
        this.enters = true;
        // 滑块点击坐标
        const offsetX = event.offsetX;
        document.ontouchmove = this.mouseMove(offsetX);
        //抬起鼠标，结束移动事件
        document.ontouchend = this.mouseUp;
      },
      mouseMove(offsetX){
        var that = this;
        return function(e){
          // e.preventDefault()
          // 滑动距离可视区域左侧的距离
          const X = e.touches ? e.touches[0].pageX : e.clientX;
          // 减去滑块偏移量
          const cl = X - (e.touches ? 0 : offsetX);
          const { left, width } = that.$refs.control.getBoundingClientRect()
          // 除去滑块按钮长度的进度条长度
          const ml = cl - left
          let progressWidth
          if (ml <= 0) {
          //进度条长度最小和最大值的界定
            progressWidth = 0
          } else if (ml >= width) {
            progressWidth = width
          } else {
            progressWidth = ml
          }
          that.progressWidth = progressWidth + 'px'
          
          // 更新当前时间
          that.updadteCurrentTime(progressWidth, width)
        }
        
      },
      mouseUp (){
          document.onmousemove = null;
          document.onmouseup = null;
          document.ontouchmove = null;
          document.ontouchend = null;
          this.enters = false;
          setTimeout(()=>{
            this.$refs.videos.play()
            this.imageShow = false;
            this.pauses = false;
          },10)
      },
      // 更新当前时间、帧号
      updadteCurrentTime(progressWidth, width) {
        this.currentTime = this.formatSeconds((progressWidth / width) * this.$refs.videos.duration)
        this.totalTime = this.formatSeconds(this.$refs.videos.duration)
        this.$refs.videos.currentTime = (progressWidth / width) * this.$refs.videos.duration
      },
      plays() {
        //是否暂停
        // this.paused = !this.paused
        // 若此刻状态是重新播放，那么点击播放时，进度条需从头开始前进
        // 进度条控制的是中间视频，this.$refs.videos
        if(this.IsApp().APP && this.IsApp().iOS){
          var map = {
            "handleName": "playFullScreenVideo",
             "params": {
                "videoUrl": this.src
              }
          }
          //苹果端返回
          window.webkit.messageHandlers.iOSAppModel.postMessage(map);
          return;
        }
        this.imageShow = false;
        if (this.$refs.videos.paused) {
          $("video").each(function (i, o) {
            $(this)[0].pause();
          });
          this.$refs.videos.play();
          this.pauses = false;
          // 按倍速播放
          // this.$refs.videos.playbackRate = this.playSpeed
          // 定时器实时刷新
          this.timer = setInterval(this.updateVideoProgress, 1000)
          this.updateVideoProgress()
        }else{
          this.$refs.videos.pause();
          this.pauses = true;
        }
      },
      showOrFalse(){
      	var state = this.$refs.controlBottom.style.display;
      	if(state == 'block'){
      		this.$refs.controlBottom.style.display = 'none';
      	}else{
      		this.$refs.controlBottom.style.display = 'block';
      	}
      },
      clearTimer() {
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }
      },
      // 更新播放时进度条长度
      updateVideoProgress() {
      //按照已播放时间和总时长的比例更新进度条长度
        this.progressWidth = (this.$refs.videos.currentTime / this.$refs.videos.duration) * 100 + '%'
        this.currentTime = this.formatSeconds(this.$refs.videos.currentTime)
        this.totalTime = this.formatSeconds(this.$refs.videos.duration)
        // 放完、暂停这两种情况，遍历所有视频，使他们的状态一致，并清除定时器
        if (this.currentTime === this.totalTime || this.$refs.videos.paused) {
          if(this.currentTime === this.totalTime){
            this.$refs.videos.currentTime = 0
            this.currentTime = '00:00'
            this.progressWidth = 0 + 'px !important';
            this.imageShow = true;
          }else{
            this.imageShow = false;
          }
          this.$refs.videos.pause()
          this.pauses = true
          this.clearTimer()
        }
      },
      // 格式化时间 
      formatSeconds(value) {
        const result = parseInt(value)
        const h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600)
        const m = Math.floor((result / 60) % 60) < 10 ? '0' + Math.floor((result / 60) % 60) : Math.floor((result / 60) % 60)
        const s = Math.floor(result % 60) < 10 ? '0' + Math.floor(result % 60) : Math.floor(result % 60)
        
        let res = ''
        res += `${m}:`
        res += `${s}`
        return res
      }
    }
}
</script>
<style lang="scss" scoped>
  .control{
    position:relative;
    cursor:pointer;
    &:hover{
      .control-wrap{
        .control-bottom {
          display:block;
        }
        .control-top{
          margin:0 auto;
          width: calc(100% - 20px);
        }
      }
    } 
    .ImageLayer{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: calc(100% - 40px);
      img{
        object-fit: cover;
      }
    }
    .scaleSet{
      width: 75% !important;
      object-fit: fill;
      transform: translateX(17%);
    }
    video{
      width:100%;
      height:100%;
    }
    .control-wrap{
      bottom: 0;
      left: 0;
      position: absolute;
      width: 100%;
      z-index: 75;
      .control-top{
        width:100%;
        height:3px;
        background-color: #f2f2f2;
        &:hover{
          
          height:5px;
          .control-top-bar .slider_circle{
            display:block;
          }
        } 
        .control-top-bar{
          position:relative;
          height:100%;
          background-color: #0d78cf;
          .slider_circle{
            position:absolute;
            display:none;
            right:-14px;
            top:-10px;
            width: 27px;
            height: 27px;
          }
          .showOrHide{
            display:block;
          }
        }
      }
      .control-bottom{
        color:#fff;
        height:35px;
        display:none;
        line-height: 22px;
        width:100%;
        transition: all .2s ease-out;
        position:relative;
        .control-mask{
          background: url(../assets/image/images/line.png) repeat-x bottom;
          bottom: 0;
          height: 100px;
          left: 0;
          pointer-events: none;
          position: absolute;
          -webkit-transition: opacity .2s ease-in-out;
          transition: opacity .2s ease-in-out;
          width: 100%;
          z-index: -1;
        }
        .control-bottom-control{
          display:flex;
          height:100%;
          justify-content:space-between;
          .control-bottom-left{
            height:100%;
            display:flex;
            align-items:center;
            div{
              margin-left:20px;
            }
            .video-play{
              width:16px;
              height:16px;
              background: url(../assets/image/images/play.png) no-repeat top center;
            }
            .video-pause{
              width:16px;
              height:16px;
              background: url(../assets/image/images/pause.png) no-repeat top center;
            }
            .timer span{
              vertical-align:text-top;
            }
          }
          .control-bottom-right{
            display:flex;
            align-items:center;
            height:100%;
            .bpx-player-ctrl-btn{
              margin-right:20px;
              position:relative;
              .bpx-player-ctrl-menu{
                position:absolute;
                left:50%;
                transform: translateX(-50%);
                bottom:32px;
                border-radius: 2px;
                background-color: hsla(0,0%,8%,.9);
                text-align: center;
                .active{
                  color:#00a1d6;
                }
                li{
                  padding: 7px 0;
                  color: hsla(0,0%,100%,.9);
                }
              }
              .icon{
                width:20px;
                height:22px;
              }
            }
            .ctrl-quality{
              .ctrl-quality-menu{
                width:70px;
              }
            }
            .ctrl-playbackrate{
              .ctrl-playbackrate-menu{
                width:70px;
              }
            }
            .player-ctrl-volume{
              .volumeBar{
                padding:10px 0 20px;
              }
              .icon-size{
                background: url(../assets/image/images/voice.png) no-repeat top center;
              }
            }
            .player-ctrl-pip{
              &:hover{
                .player-ctrl-pip-menu{
                  display:block;
                }
              }
              .player-ctrl-pip-menu{
                width:70px;
                display:none;
              }
              .icon-news{
                background: url(../assets/image/images/iconPip.png) no-repeat top center;
              }
            }
            .player-ctrl-web{
              &:hover{
                .player-ctrl-web-menu{
                  display:block;
                }
              }
              .player-ctrl-web-menu{
                width:70px;
                display:none;
              }
              .icon-full-screen{
                background: url(../assets/image/images/iconFullS.png) no-repeat top center;
              }
            }
            .player-ctrl-setting{
              .icon-s-tools{
                background: url(../assets/image/images/iconSet.png) no-repeat top center;
              }
              .ctrl-setting-menu{
                width:120px;
                padding: 0 10px;
                li{
                  display:flex;
                  .el-switch{
                    margin-left:26px;
                  }
                }
                li:nth-child(1):hover{
                  color: #0d78cf;
                }
                li:nth-child(1){
                  padding: 7px 0 0;
                }
                li:nth-child(3){
                  flex-direction:column;
                  text-align:left;
                  padding-top:0;
                  .ctrl-setting-scale{
                    span{
                      display:inline-block;
                      width:30px;
                      height:20px;
                      
                      background-color: hsla(0,0%,100%,.3);
                      margin-left:6px;
                      text-align:center;
                      border-radius: 3px;
                      padding: 0 3px;
                    }
                    span:first-child{
                      margin-left:0;
                    }
                    .active{
                      background-color:#0d78cf;
                      color:#fff;
                    }
                  } 
                }
              }
            }
          }
        }
      }
    }
  }
  @media screen   and (max-width: 340px) {
    .bpx-player-ctrl-btn{
      margin-right:10px !important;
    }
  }
  @media screen   and (max-width: 460px) {
    .videoAdapter,.ctrl-quality{
          display:none;    
    }
  }
  // video::-webkit-media-controls {
  //     display: none !important;
  // }

  // /* 针对Safari的额外样式 */
  // video::-webkit-media-controls-start-playback {
  //     display: none !important;
  // }

  // video::-webkit-media-controls-fullscreen-button {
  //     display: none !important;
  // }

  // video::-webkit-media-controls-timeline {
  //     display: none !important;
  // }

  // video::-webkit-media-controls-current-time-display {
  //     display: none !important;
  // }

  // video::-webkit-media-controls-time-remaining-display {
  //     display: none !important;
  // }

  // video::-webkit-media-controls-mute-button {
  //     display: none !important;
  // }

  // video::-webkit-media-controls-toggle-closed-captions-button {
  //     display: none !important;
  // }

  // video::-webkit-media-controls-volume-slider {
  //     display: none !important;
  // }
  /* 全屏样式 统一 兼容性问题 */
  :not(:root):-webkit-full-screen {
      /* background: #fff !important; */
      position: fixed !important;
      top: 100px !important;
      left: 0 !important;
      width: 100% !important;
      height: 100% !important;
  }

  :not(:root):-ms-full-screen {
      /* background: #fff !important; */
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      width: 100% !important;
      height: 100% !important;
  }

  :not(:root):-moz-full-screen {
      /* background: #fff !important; */
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      width: 100% !important;
      height: 100% !important;
  }

  :not(:root):fullscreen {
      /* background: #fff !important; */
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      width: 100% !important;
      height: 100% !important;
  }

  :not(:root):-webkit-full-screen::backdrop {
      background: #fff !important;
  }
</style>
<style>
  .slider_circle .el-slider__button{
    margin: 7px 0 0 9px;
  }
  .el-slider__button {
    width:7px !important;
    height:7px !important;
    
  }
  .el-slider.is-vertical{
    margin-top:10px;
  }
  .el-slider__button-wrapper.hover, .el-slider__button-wrapper:hover,.el-slider__button.hover, .el-slider__button:hover{
    cursor:pointer !important;
  }
  .el-slider.is-vertical .el-slider__runway,.el-slider.is-vertical .el-slider__bar{
    width:3px !important;
  }
  .el-slider.is-vertical .el-slider__button-wrapper{
    left:-17px;
  }
  
</style>



// WEBPACK FOOTER //
// src/components/videos.vue